import React from 'react';
import { COLORS } from '../../common/colors';

type MacroType = 'protein' | 'fat' | 'carb' | 'sugar';

interface MacroBulletProps {
    type: MacroType;
}

const MacroBullet: React.FC<MacroBulletProps> = ({ type }) => {
    return <div className="w-1.5 h-1.5 mr-2" style={{ backgroundColor: COLORS[type] }} />;
};

export default MacroBullet;
